import AuthService from './services/auth.service';
import Router from 'vue-router';

const About = () => import('./Pages/About.vue');
const PrivacyPolicy = () => import('./Pages/PrivacyPolicy.vue');
const TermsOfUse = () => import('./Pages/TermsOfUse.vue');
const UserTermsOfUse = () => import('./Pages/UserTermsOfUse.vue');
const Home = () => import('./Pages/Home.vue');
const Login = () => import('./Pages/Login.vue');
const Register = () => import('./Pages/Register.vue');
const Code = () => import('./Pages/Code.vue');
const ProfilePage = () => import('./Pages/ProfilePage.vue');
const Projects = () => import('./Pages/Projects.vue');
const AdminProjects = () => import('./Pages/Admin/Projects.vue');
const Project = () => import('./Pages/Project.vue');
const Dashboard = () => import('./Pages/Admin/Dashboard.vue');
const Users = () => import('./Pages/Admin/Users.vue');
const Tasks = () => import('./Pages/Admin/Tasks.vue');
const Contracts = () => import('./Pages/Admin/Contracts.vue');
const Config = () => import('./Pages/Admin/Config.vue');
const AddTask = () => import('./Pages/AddTask.vue');
const AddTaskComplete = () => import('./Pages/AddTaskComplete.vue');
const AddSpecialist = () => import('./Pages/AddSpecialist.vue');
const Step2 = () => import('./Pages/New/Step2.vue');
const StopProject = () => import('./Pages/StopProject.vue');
const EndProject = () => import('./Pages/EndProject.vue');
const Step1 = () => import('./Pages/New/Step1.vue');
const DeclineProject = () => import('./Pages/DeclineProject.vue');
const Auth = () => import('./Pages/Auth.vue');
const AcceptProject = () => import('./Pages/AcceptProject.vue');
const CreateTeam = () => import('./Pages/CreateTeam.vue');
const Sent = () => import('./Pages/New/Sent.vue');
const ConfirmTask = () => import('./Pages/ConfirmTask.vue');
const Email = () => import('./Pages/Email.vue');
const MagicLink = () => import('./Pages/MagicLink.vue');
const ProjectRating = () => import('./Pages/ProjectRating.vue');
const ForgotPassword = () => import('./Pages/ForgotPassword.vue');
const PasswordReset = () => import('./Pages/PasswordReset.vue');
const Password = () => import('./Pages/Password.vue');
const InviteNewUser = () => import('./Pages/InviteNewUser.vue');
const ErrorMagicLinkExpired = () => import('./Pages/Error/MagicLink/ErrorMagicLinkExpired.vue');
import store from "@/store";

export const PROJECT_RATING_PATH = '/project/:giverProjectUserId/rating';
export const PROJECT_PATH = '/project/:projectUserId';

let VueRouter = new Router({
    mode: 'history',
    routes: [
        { path: '/', component: Home, },
        { path: '/login', component: Login, },
        { path: '/register', component: Register, },
        { path: '/auth', component: Auth, },
        { path: '/about', component: About, },
        { path: '/privacy-policy', component: PrivacyPolicy, },
        { path: '/terms-of-use', component: TermsOfUse, },
        { path: '/terms-of-use/accept', component: UserTermsOfUse, },
        { path: '/code', component: Code, },
        { path: '/email', component: Email, },
        { path: '/ml/:magicLinkValue', component: MagicLink, },
        { path: '/forgot-password', component: ForgotPassword, },
        { path: '/reset-password', component: PasswordReset, },

        { path: '/profile', component: ProfilePage, },
        { path: '/profile/password', component: Password, },
        { path: '/projects', component: Projects, },
        { path: '/project/sent', component: Sent, },
        { path: '/project/new', component: Step1, },
        { path: PROJECT_PATH, component: Project, },
        { path: '/project/:projectUserId/decline', component: DeclineProject, },
        { path: '/project/:projectUserId/accept', component: AcceptProject, },
        { path: '/project/:projectUserId/add-task/:tabId', component: AddTask, },
        { path: '/project/:projectUserId/task/add/complete', component: AddTaskComplete, },
        { path: '/project/:projectUserId/add-specialist', component: AddSpecialist, },
        { path: '/project/:projectUserId/pick-manager', component: Step2, },
        { path: '/project/:projectUserId/create-team', component: CreateTeam, },
        { path: '/project/:projectUserId/confirm-task/:taskId', component: ConfirmTask, },
        { path: '/project/:projectUserId/stop', component: StopProject, },
        { path: '/project/:projectUserId/end', component: EndProject, },
        { path: PROJECT_RATING_PATH, component: ProjectRating, },

        { path: '/admin/dashboard', component: Dashboard, },
        { path: '/admin/projects', component: AdminProjects, },
        { path: '/admin/users', component: Users, },
        { path: '/admin/tasks', component: Tasks, },
        { path: '/admin/contracts', component: Contracts, },
        { path: '/admin/config', component: Config, },

        { path: '/user/new/:projectUserId', component: InviteNewUser, },

        { path: '/error/ml/expired', component: ErrorMagicLinkExpired, },

        { path: '*', redirect: '/' },
    ]
});

export function pushTo(path, map, router) {
    let p = path;
    for (const [varName, varValue] of map) {
        p = p.replace(':' + varName, varValue);
    }
    router.push(p);
}

export function pushToProjectRating(giverProjectUserId, router) {
    let map = new Map([
        ["giverProjectUserId", giverProjectUserId]
    ]);
    pushTo(PROJECT_RATING_PATH, map, router);
}

export function pushToProject(projectUserId, router) {
    let map = new Map([
        ["projectUserId", projectUserId]
    ]);
    pushTo(PROJECT_PATH, map, router);
}

VueRouter.beforeEach(async(to, from, next) => {
    if (to.query?.token) {

        await AuthService.login(to.query.token);

        next('/projects');
    }
    const isUnauthorizedRoute = [
        '',
        '/',
        '/login',
        '/register',
        '/about',
        '/code',
        '/auth',
        '/terms-of-use',
        '/privacy-policy',
        '/forgot-password',
        '/reset-password',
        '/project/new',
        '/error/magic-link/expired',
    ].some(path => to.path && to.path === path);
    const isAllowedRouteWhenAuthorized = [
        '/',
        '/login',
        '/about',
        '/terms-of-use',
        '/privacy-policy',
        '/project/new',
    ].some(path => to.path && to.path === path);

    function matchesPattern(path, regex) {
        var rgxp = new RegExp(regex, "g");
        return path.match(rgxp) !== null;
    }

    if (AuthService.isAuthorized) {
        if (isUnauthorizedRoute && !isAllowedRouteWhenAuthorized) {
            next('/projects');
        } else if (to.path.startsWith('/admin')) {
            await store.dispatch('global/getUser');
            if (store.getters['global/isAdmin']) {
                next();
            } else {
                next('/projects');
            }
        } else {
            next();
        }
    } else if (isUnauthorizedRoute) {
        next();
    } else if (to.path && matchesPattern(to.path, '\\/ml\\/\\S+')) {
        next();
    } else {
        AuthService.logout();
        next('/');
    }
});

export default VueRouter;
